import {
  Button,
  DialogActions,
  DialogContent,
  Dialog,
  Divider,
  IconButton,
  Typography,
  Backdrop,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
  CircularProgress,
  Grid
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { connect } from 'react-redux';
import { setHistoricalMaterialFilter } from 'src/store/actions/materialActions';
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { FaTree } from 'react-icons/fa';
import { AiOutlineCheckSquare } from 'react-icons/ai';
import { getUser } from 'src/utils/Common';
import { resetMaterials, getMaterialRequest } from 'src/store/actions';
import Page from 'src/components/Page';
const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  },
  DefectDiv: {
    margin: 0,
    padding: theme.spacing(1)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1)
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    color: 'white',
    padding: '2px'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  chipRoot: {
    height: '72px',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5)
    }
  }
}));

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography component="span">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon color="primary" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const SelectDialog = props => {
  const { t } = useTranslation('work_order');
  const [labelTumuDaralt, setlabelTumuDaralt] = React.useState(t('lblTumu'));
  const theme = useTheme();
  const SessionUser = getUser();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const handleChangeAgac = e => {
    props.setHistoricalMaterialFilter(e.target.checked ? 1 : 0);
  };

  const [loading, setLoading] = React.useState(false);

  function loadMaterialHistory() {
    var RequestData = props.tasks1.tasks[0];
    var ServiceShopId = SessionUser.ServiceShopId;
    setLoading(true);
    axios
      .get(`/GetHistoricalBom/${RequestData.ModelCode}/${RequestData.ProductionMonth || 0}/${RequestData.ProductionYear|| 0}/${ServiceShopId}`)
      .then(response => {
        // props.resetMaterials();
        props.getMaterialRequest(RequestData.ModelCode, 1, 1, RequestData.ProductionYear || 0, RequestData.ProductionMonth || 0, RequestData.ReceiptNo || 0);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
      
  }

  const loadMaterialCurrent = () => {
    var RequestData = props.tasks1.tasks[0];
    props.resetMaterials();
    props.getMaterialRequest(RequestData.ModelCode, 1, 1, RequestData.ProductionYear || 0, RequestData.ProductionMonth || 0, RequestData.ReceiptNo || 0);
  }

  return (
    <Page>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={props.open}
        onClose={props.onClose}
        onEntering={props.onEntering}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="customized-dialog-title" onClose={props.onClose}>
          <Typography component="span" variant="h6" gutterBottom>
            {props.title}
          </Typography>
          <Divider />
          <Divider color="secondary" />
          <Typography component="span" variant="body2" gutterBottom>
            {props.SelectedItems}
          </Typography>
        </DialogTitle>
        <DialogContent dividers className={classes.DefectDiv}>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              {props.SearchField}
            </Typography>
            {props.defectReducer.filterChange ? (
              <Backdrop className={classes.backdrop} open={props.defectReducer.filterChange}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              props.children
            )}
          </>
        )}
      </DialogContent>
        {props.actions && (
          <DialogActions>
            {props.isDefectDialog &&
              <>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => loadMaterialCurrent()}
                  endIcon={<AiOutlineCheckSquare style={{ color: 'green' }} size="20" />}
                >
                  {t('lblCurrent')}
                </Button>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => loadMaterialHistory()}
                  endIcon={<FaTree style={{ color: 'orange' }} size="20" />}
                >
                  {t('lblHistory')}
                </Button>
              </>
            }
            <Button
              color="primary"
              variant="contained"
              onClick={props.onClose}
              endIcon={<CheckCircleOutlineIcon />}
            >
              {t('lblDone')}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Page>
  );
};

const mapStateToProps = state => state;

const mapDispatchToProps = {
  setHistoricalMaterialFilter,
  resetMaterials,
  getMaterialRequest
};

export default connect(mapStateToProps
  , mapDispatchToProps
)(SelectDialog);
